const folders = [
    {
        'id': 0,
        'handle': 'inbox',
        'title': 'module.inbox',
        'icon': 'inbox'
    },
    {
        'id': 1,
        'handle': 'sent',
        'title': 'module.sent',
        'icon': 'mail-send'
    },
    {
        'id': 2,
        'handle': 'drafts',
        'title': 'module.drafts',
        'icon': 'email-open'
    },
    {
        'id': 3,
        'handle': 'spam',
        'title': 'module.spam',
        'icon': 'info'
    },
    {
        'id': 4,
        'handle': 'trash',
        'title': 'module.trash',
        'icon': 'delete'
    }
];

export default folders;